import { defineStore } from "pinia";
import { type IAuthStoreState } from "~/types/store";
import {
  NextJournalPagesService,
  type ILoggedUserInfo
} from "@frontiers-vue3/public-pages";
import type { IToolsDropdownExtended } from "~/types/api";

export const useAuthStore = defineStore("authStore", {
  state: (): IAuthStoreState => {
    return {
      loggedUser: undefined,
      isManageTopicWheelAvailable: false
    };
  },

  actions: {
    async setLoggedUser(loggedUser: ILoggedUserInfo) {
      this.loggedUser = loggedUser;
      this.setIsManageTopicWheelAvailable();
    },

    async setIsManageTopicWheelAvailable() {
      try {
        new NextJournalPagesService()
          .getToolsItems()
          .then((toolsItems: IToolsDropdownExtended) => {
            const isEofOrConfigUser = toolsItems.loggedUser?.roles.some(
              (userRole) => userRole === "EOF" || userRole === "CONFIG"
            );

            if (isEofOrConfigUser) {
              this.isManageTopicWheelAvailable = true;
              return;
            } else {
              const { currentResearchTopic } = useMain();
              const isTopicEditor =
                currentResearchTopic.topicEditors.some(
                  (topicEditor) => topicEditor.userId === this.loggedUser?.id
                ) ?? false;
              this.isManageTopicWheelAvailable = isTopicEditor;
            }
          });
      } catch (e) {
        console.warn("Tools error: ", e);
        return false;
      }
    },

    unsetLoggedUser() {
      this.loggedUser = undefined;
    }
  },

  getters: {
    isUserLogged(): boolean {
      return this.loggedUser?.id ? true : false;
    }
  }
});
